/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { type AxiosRequestConfig } from "axios";
import { env } from '$env/dynamic/public';
import { axiosHandler } from "../axiosHandler";
import type { FloraOutput } from "./type";
import { datadogLogs } from "@datadog/browser-logs";
import { startCreateTimer } from "$lib/utilities/disconnectConversation";

type ReturnType = {
    status: string,
    conversation_id: string,
    message: FloraOutput
}

export const startConversation = async (requestData: {
    token: string,
    email: string,
    lastName: string,
    firstName: string,
    brand: string,
    agent_direct: unknown,
    contactId: string,
    browser_uuid: string
    channel: string,
    entry_point: string,
    entry_page_type: string,
    enterprise_id: string,
}): Promise<ReturnType> => {
    const protocol = env.PUBLIC_NODE_ENV === 'dev' ? 'http://' : 'https://'
    const originOrFastlyRoute = env.PUBLIC_ORIGIN_ROUTING ? '/webchat/flora/start' : '/r/api/conversational/garden-webchat-api/flora/start';
    const domain = env.PUBLIC_ORIGIN_ROUTING ? env.PUBLIC_ORIGIN_DOMAIN_URL : env.PUBLIC_DOMAIN_URL
    const route = env.PUBLIC_NODE_ENV === 'dev' ? '/flora/start' : originOrFastlyRoute

    try {
        const config: AxiosRequestConfig = {
            method: 'POST',
            url: `${protocol}${domain}${route}`,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${requestData.token}`, },
            data: requestData,
            timeout: 30000
        };
        const response = await axiosHandler<ReturnType>(config);
        startCreateTimer(response?.data?.conversation_id)
        datadogLogs.logger.info(
            `[Conv-ui] Conversation Started - brand: ${requestData.brand} channel: ${requestData.channel} browser_uuid: ${requestData.browser_uuid} conversation_id: ${response?.data?.conversation_id}`
        );
        return response?.data
    } catch (error) {
        datadogLogs.logger.error(`[Conv-ui] Conversation Started Failure - brand: ${requestData.brand} browser_uuid: ${requestData.browser_uuid} error: ${error}`)
        return {} as ReturnType
    }
}